import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyRentalDetailsSectionComponent } from './property-rental-details-section.component';
import {
    TgCheckboxModule,
    TgGridModule,
    TgInputMaskModule,
    TgInputModule,
    TgRadioModule,
    TgSelectModule
} from '@trademe/tangram';
import { DraftValidationModule } from '@classifieds-sell/shared';

@NgModule({
    declarations: [PropertyRentalDetailsSectionComponent],
    exports: [PropertyRentalDetailsSectionComponent],
    imports: [
        CommonModule,
        TgGridModule,
        TgSelectModule,
        TgInputMaskModule,
        TgInputModule,
        TgCheckboxModule,
        TgRadioModule,
        DraftValidationModule
    ]
})
export class PropertyRentalDetailsSectionModule {}
